import { useQuery } from '@tanstack/react-query';
import { widgetService } from '@services/widgetService';
import { useWidgetStore } from '@store/widgetStore';
import { MIN_REFRESH_INTERVAL } from '@/utils';

export function useWidgetData<T = unknown>(
  widgetId: string,
  type: string,
  params?: Record<string, unknown>,
  refreshInterval = 0,
) {
  const refreshToken = useWidgetStore((s) => s.refreshTokens[widgetId] ?? 0);

  return useQuery<T>({
    queryKey: ['widget-data', type, widgetId, params, refreshToken],
    queryFn: () => widgetService.fetchData<T>(type, params),
    refetchInterval:
      refreshInterval && refreshInterval >= MIN_REFRESH_INTERVAL ? refreshInterval * 1000 : false,
    staleTime: 30_000,
  });
}
